<template>
  <div class="weixiaomo">
    <div class="knowledge">
      <div class="knowledge-con" v-for="(i,k) in dataRef.processModels">
        <div style="display: flex;margin-bottom: 10px">
          <div class="FontDetailsTile">{{ i.process }}</div>
          <div class="FontDetailsCon">
              <span v-if="i.imgs">
                <img :src="i.imgs" alt="">
              </span>
            <span v-else>{{ i.conList ? i.conList[0] : i.con }}</span>
          </div>
        </div>
        <div style="width: 100%" v-if="i.conList">
          <div class="FontDetailsTile_copy" v-for="(ii,kk) in i.conList.length -1" :key="ii+kk">{{
              i.conList[ii]
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="video-con">
      <div class="video-con_title">{{dataRef.list.chineseFont}}</div>
      <video @ended="ended" v-if="!dataRef.isSwitch" :src="dataRef.list.videoUrl"
             style="width: 100%;  object-fit: cover" controls
             controlslist="nodownload"
      ></video>
      <video ref="video" v-else src="http://img.dwhs.cn/cdn/video/%E5%8D%AB%E5%B0%8F%E5%A2%A8%E5%9D%90%E5%A7%BF%E6%8F%90%E9%86%92%EF%BC%88%E5%8A%A0%E5%AD%97%E5%B9%95%EF%BC%893.mp4"
             style="width: 100%;  object-fit: cover" controls
             controlslist="nodownload"
      ></video>
    </div>
    <img @click="onOutCourseware" style="width: 123px;height: 123px" class="tc"
         src="data:image/png;base64,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"
         alt="">
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, reactive, ref, nextTick} from "vue";
import {useRoute, useRouter} from "vue-router";

const route = useRoute()
const router = useRouter()
let dataRef = reactive({
  list: [],
  processModels: [],
  isSwitch: false
})
onMounted(() => {
  let imgType = ['jpeg', 'bmp', 'jpg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp', 'avif', 'apng']
  // console.log(JSON.parse(localStorage.getItem('weixiaomo')))
  dataRef.list = JSON.parse(localStorage.getItem('weixiaomo'))
  dataRef.processModels = JSON.parse(JSON.stringify(dataRef.list)).processModels
  dataRef.processModels.forEach(async (i) => {
    if (imgType.indexOf(i.processContent.split('.')[i.processContent.split('.').length - 1]) !== -1) {
      i.imgs = i.processContent
    } else {
      i.conList = await characterString(i.processContent, 15)
    }
  })

})

let video = ref(null)

const ended = async () => {
  dataRef.isSwitch = !dataRef.isSwitch
  if (dataRef.isSwitch) {
    await nextTick(() => {
      video.value.play()
    })
  }
}


const onOutCourseware = async () => {
  await router.back()
}
const characterString = async (str, length) => {
  let strArr = []
  for (let i = 0; i < str.length; i += length) {
    strArr.push(str.slice(i, i + length))
  }
  return strArr
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: fz;
  src: url('https://img.dwhs.cn/cdn/font/chuyuan176.ttf');
}

.weixiaomo {
  background: url("~@/assets/image/conference/weixiaomobg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;

  .knowledge {
    position: absolute;
    width: 639px;
    height: 420px;
    left: 142px;
    top: 423px;

    .knowledge-con {
      width: 100%;
      //height: 57px;
      //border-radius: 57px;
      height: auto;
      color: #FFFFFF;
      letter-spacing: 5px;
      font-family: 'fz';
      //background-color:#F6E25F;
      .FontDetailsTile_copy {
        display: flex;
        align-items: center;
        width: 80%;
        height: 57px;
        border-radius: 57px;
        color: #333;
        letter-spacing: 5px;
        font-family: 'fz';
        background-color: #fff;
        margin: 0px 0px 10px 127px;
        font-size: 28px;
      }

      .FontDetailsTile {
        width: 150px;
        height: 57px;
        background-color: #E8380D;
        //border-radius: 57px;
        border-top-left-radius: 57px;
        border-bottom-left-radius: 57px;
        font-size: 30px;
        color: #FFFFFF;
        text-align: center;
        line-height: 50px;
        font-family: 'fz';
      }

      .FontDetailsCon {
        font-size: 28px;
        letter-spacing: 3px;
        height: 57px;
        border-top-right-radius: 57px;
        border-bottom-right-radius: 57px;
        background-color: #fff;
        width: 100%;
        display: flex;
        align-items: center;

        img {
          height: 40px;
          width: 100%;
          //margin-top: 5px;/**/
        }

        span {
          margin-left: 5px;
          font-family: 'fz';
          color: #333;
        }
      }

    }
  }

  .video-con {
    width: 647px;
    height: 647px;
    position: absolute;
    top: 90px;
    right: 164px;

    .video-con_title {
      font-size: 78px;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 94px;
      text-align: center;
      font-family: 'fz';
      margin-bottom: 17px;
    }
  }

  .tc {
    position: absolute;
    right: 34px;
    top: 25px;
    cursor: pointer;
  }
}
</style>
